
/* injects from baggage-loader */

'use strict';

export default function (app) {
    app.filter('startFrom', startFrom);
    
    function startFrom(){
        return function (input, start) {
            start = +start; //parse to int
            return input.slice(start);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/core/filters/start-from.filter.js